module.exports = __webpack_public_path__ + "img/balogo.d0289dc0.png";